var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['axiome-logique-container', 'axiome-logique-has-self']},[_c('PropertyValue',{attrs:{"values":_vm.onPropertyLiterals,"leftMargin":false,"showLanguageBadge":_vm.showLanguageBadge}}),_c('span',{class:['axiome-logique-operand', ' ml-2', ' mr-2', { 'axiome-logique-operand-level0': _vm.level0 }]},[_vm._v("some self")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }